"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hyperfetch = exports.createMethod = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const fromPairs_1 = __importDefault(require("lodash/fromPairs"));
const noop_1 = __importDefault(require("lodash/noop"));
const debug_1 = __importDefault(require("debug"));
const create_request_1 = require("./create-request");
__exportStar(require("./types"), exports);
const debug = debug_1.default('hyperfetch');
const headersToObject = (headers) => fromPairs_1.default([...headers.entries()]);
const fullResponseJsonHandler = async (x) => {
    const { headers } = x;
    const contentType = headers.get('Content-Type');
    if (contentType.includes('application/json')) {
        return {
            body: await x.json(),
            status: x.status,
            headers: headersToObject(x.headers),
        };
    }
    return {
        body: await x.text(),
        status: x.status,
        headers: headersToObject(x.headers),
    };
};
const simpleResponseJsonHandler = async (x) => {
    const { headers } = x;
    const contentType = headers.get('Content-Type');
    if (contentType.includes('application/json')) {
        return await x.json();
    }
    return await x.text();
};
const throwIfBadStatus = ({ status, parsedResponse }) => {
    if (status >= 400 && status < 600) {
        throw new Error(JSON.stringify(parsedResponse.body || parsedResponse));
    }
};
exports.createMethod = (method, config) => (ep) => async ({ params, data, query, opts, } = {}) => {
    const fetcher = config.fetch || cross_fetch_1.default;
    const req = create_request_1.createRequest({ ep, config }, { method, params, data, query, opts, baseOpts: config.baseOpts });
    debug('request: %j', req);
    const res = await fetcher(req.url, Object.assign({ method: req.method, body: req.body }, req.opts));
    const parsedResponse = await (config.responseHandler ||
        (config.fullResponse ? fullResponseJsonHandler : simpleResponseJsonHandler))(res);
    res.parsedResponse = parsedResponse;
    (config.throwIfBadStatus || throwIfBadStatus)(res);
    debug('response: %O', parsedResponse);
    const throwIfError = config.throwIfError || noop_1.default;
    throwIfError(parsedResponse);
    debug('done: (no errors)');
    return parsedResponse;
};
exports.hyperfetch = (config = {}) => {
    return {
        post: exports.createMethod('POST', config),
        get: exports.createMethod('GET', config),
        put: exports.createMethod('PUT', config),
        del: exports.createMethod('DELETE', config),
    };
};
//# sourceMappingURL=index.js.map